<template>
    <div>
        <!-- Modal Alergias -->
        <div class="modal fade" id="alergiaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Alergias: {{ paciente ? paciente.st_nome : 'Aguarde...' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state
                            v-if="!paciente || !paciente.alergias || !paciente.alergias.filter(item => item.fl_ativo).length"
                            msg="Nenhuma alergia registrada"
                            icon="fa-solid fa-droplet-slash"
                            action="Incluir"
                            :method="incluir" />

                        <div v-else-if="paciente">
                            <div v-for="(alergia, iax) in paciente.alergias" :key="iax">
                                <div class="form-row" v-show="alergia.fl_ativo">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="alergia_tipos.index"
                                            optionsData="id_alergia_tipo"
                                            :edicao="!alergia.id_alergia"
                                            :validate="validate"
                                            required
                                            v-model="alergia.id_alergia_tipo">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-danger" @click="alergia.fl_ativo = false">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Observações..."
                                            v-model="alergia.st_observacoes" />
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir()">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            paciente: null, 
            validate: false, 
            id_paciente: null, 
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        AzSubmit, 
    }, 

    methods: { 
        abrir(id_paciente) { 
            this.id_paciente = id_paciente;
            this.paciente = null;
            this.validate = false;

            $('#alergiaModal').modal('show');

            this.carregar();
        },

        carregar() { 
            this.$util.load(this, { 
                service: 'pacientes',
                func: 'show', 
                parms: { 
                    id: this.id_paciente, 
                },
                with: ['alergias'],
                loadTo: (res) => { 
                    this.paciente = res;
                }
            });
        },

        incluir() { 
            this.validate = false;
            
            this.paciente.alergias.push({ 
                id_alergia: null, 
                id_paciente: this.id_paciente,
                id_alergia_tipo: "", 
                fl_ativo: true, 
            });
        }, 

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'alergias',
                func: 'atualizar', 
                dados: { 
                    alergias: this.paciente.alergias
                }, 
                callback: res => { 
                    $('#alergiaModal').modal('hide');

                    if ( res.refresh ) { 
                        this.$emit('refresh');
                    }
                }
            });
        },
    }
}
</script>